import { hasFeature } from '@/ui/auth/auth';
import { h, defineComponent } from 'vue';
import { level, pageTitle } from '@/ui/components';
import { t } from '@/ui/i18n/i18n';
import * as qs from '@/ui/queryState';
import { secondaryNavbar, TabItem } from '@/ui/components/navigation/SecondaryNavbar';
import { AnalyticsTabNames, queryTabName } from '@/ui/components/navigation/constants';
import { OverviewPage } from '@/ui/pages/analytics/Overview/OverviewPage';
import { NegativeResponsesPage } from '@/ui/pages/analytics/NegativeResponses/NegativeResponsesPage';
import { ScoresPage } from '@/ui/pages/analytics/Scores/ScoresPage';
import { OverdueInspectionsPage } from '@/ui/pages/analytics/OverdueInspections/OverdueInspectionsPage';
import { IssuesPage } from '@/ui/pages/analytics/Issues/IssuesPage';
import { SummaryChecklistsPage } from '@/ui/pages/analytics/SummaryChecklists/SummaryChecklistsPage';

export const AnalyticsPage = defineComponent({
  name: 'AnalyticsPage',
  setup() {
    const activeTab = qs.stringEnum<AnalyticsTabNames>(
      queryTabName,
      Object.values(AnalyticsTabNames),
      AnalyticsTabNames.OVERVIEW,
      false,
    );

    const secondaryTabItems : TabItem[] = [
      {
        value: AnalyticsTabNames.OVERVIEW,
        label: t('analytics.overview'),
        icon: 'chart-bar',
        underLineColor: 'blue',
      },
      {
        value: AnalyticsTabNames.NEGATIVE_RESPONSES,
        label: t('analytics.negative-responses'),
        icon: 'minus-circle',
        underLineColor: 'orange',
      },
      {
        value: AnalyticsTabNames.SCORES,
        label: t('analytics.scores'),
        icon: 'trophy-alt',
        underLineColor: 'green',
      },
      {
        value: AnalyticsTabNames.OVERDUE_INSPECTIONS,
        label: t('analytics.overdue-inspections'),
        icon: 'alarm-clock',
        underLineColor: 'blue',
      },
      {
        value: AnalyticsTabNames.ISSUES,
        label: t('analytics.issues'),
        icon: 'bullhorn',
        underLineColor: 'red',
      },
      {
        value: AnalyticsTabNames.SUMMARY,
        label: t('analytics.summary'),
        icon: 'file-alt',
        underLineColor: 'blue',
      },
    ];

    const getTab = () => {
      switch (activeTab.value) {
        case AnalyticsTabNames.OVERVIEW:
          return OverviewPage;
        case AnalyticsTabNames.NEGATIVE_RESPONSES:
          return NegativeResponsesPage;
        case AnalyticsTabNames.SCORES:
          return ScoresPage;
        case AnalyticsTabNames.OVERDUE_INSPECTIONS:
          return OverdueInspectionsPage;
        case AnalyticsTabNames.ISSUES:
          return IssuesPage;
        case AnalyticsTabNames.SUMMARY:
          return SummaryChecklistsPage;
        default:
          throw new Error('Invalid tab selected. Please use AnalyticsTabEnum enumeration');
      }
    };

    return function render() {
      return h('div', { class: 'legacy-analytics' }, [
        level(
          [
            pageTitle(t('common.analytics')),
          ],
        ),
        hasFeature('analytics') ? secondaryNavbar({
          props: { value: activeTab.value, tabItems: secondaryTabItems },
          on: {
            input: (value: AnalyticsTabNames) => {
              activeTab.value = value;
            },
          },
        }) : null,
        h(getTab()),
      ]);
    };
  },
});
